import React, {useState} from "react";
import {isEmpty} from "lodash";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  FormText,
  Input,
  Row,
} from "reactstrap";
import CommonHeader from "../../components/Headers/CommonHeader";
import SafeView from "../../components/safeView/SafeView";
import {getUserProfile} from "../../redux/Selectors/users.selector";
import {
  requestUserProfile,
  sendEditUserModalData,
} from "../../redux/Actions/users.action";
import Settings from "./Settings";
import {useDisclosure} from "../../hooks/useDisclosure";
import VerifyMobileModal from "./verifyMobileModal";
import "./profile.scss";
import PhoneInput from "react-phone-number-input";

const Profile = () => {
  const dispatch = useDispatch();
  const [submitted, setSubmitted] = useState(false);
  const userDetails = useSelector(getUserProfile);
  const initialState = {...userDetails};
  const [profile, setProfile] = useState(initialState);
  const {isOpen, onOpen, onClose} = useDisclosure();
  const {
    first_name = "",
    last_name = "",
    username = "",
    email,
    date_joined,
    last_login,
    phone_number,
    settings = {},
  } = profile;

  let fullName = `${first_name} ${last_name}`;

  if (fullName === " ") {
    if (username === "") {
      fullName = email;
    } else {
      fullName = username;
    }
  }

  const handleOnChange = (e, name) => {
    const updateDate = Object.assign({}, profile, {
      [name]: e?.target?.value ?? null,
    });

    setProfile(updateDate);
  };

  const handleChange = (e) => {
    const {value, name, type, checked} = e.target;

    const updateData = Object.assign({}, profile, {
      settings: {...settings, [name]: type === "checkbox" ? checked : value},
    });

    setProfile(updateData);
  };

  const handleSave = () => {
    setSubmitted(true);
    if (!isEmpty(email)) {
      const callback = (response) => {
        if (response?.data?.verified === false) {
          onOpen();
        } else {
          dispatch(requestUserProfile());
        }
      };
      dispatch(sendEditUserModalData(profile, callback));
    } else {
      toast.error("Email cannot be empty");
    }
  };

  return (
    <SafeView>
      {isOpen && (
        <VerifyMobileModal
          email={email}
          isOpen={isOpen}
          onCancel={onClose}
          phoneNumber={phone_number}
        />
      )}
      <CommonHeader
        content={"Save Changes"}
        handleAddClick={handleSave}
        testID={"submit-btn"}
      />
      <div className="profile-details-container">
        <Row>
          <Col xl="8">
            <Card className="bg-secondary shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">My account</h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <h6 className="heading-small text-muted mb-4">User information</h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-date-joined"
                          >
                            Date joined
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-date-joined"
                            placeholder="Date joined"
                            type="text"
                            value={date_joined}
                            disabled={true}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-last-login"
                          >
                            Last login
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-last-login"
                            placeholder="Last login"
                            type="text"
                            value={last_login}
                            disabled={true}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-username">
                            Username
                          </label>
                          <Input
                            className="form-control-alternative"
                            defaultValue="lucky.jesse"
                            id="input-username"
                            placeholder="Username"
                            type="text"
                            value={username}
                            onChange={(e) => handleOnChange(e, "username")}
                            disabled={true}
                            data-cy={"username"}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-email">
                            Email address <span className="text-red">*</span>
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-email"
                            placeholder="johndoe@example.com"
                            type="email"
                            value={email}
                            onChange={(e) => handleOnChange(e, "email")}
                            data-cy={"email"}
                            invalid={isEmpty(email) && submitted}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-first-name"
                          >
                            First name
                          </label>
                          <Input
                            className="form-control-alternative"
                            defaultValue="Lucky"
                            id="input-first-name"
                            placeholder="First name"
                            type="text"
                            value={first_name}
                            onChange={(e) => handleOnChange(e, "first_name")}
                            data-cy={"first_name"}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-last-name">
                            Last name
                          </label>
                          <Input
                            className="form-control-alternative"
                            defaultValue="Jesse"
                            id="input-last-name"
                            placeholder="Last name"
                            type="text"
                            value={last_name}
                            onChange={(e) => handleOnChange(e, "last_name")}
                            data-cy={"last_name"}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-last-name">
                            Mobile number with country code
                          </label>
                          <PhoneInput
                            style={{}}
                            placeholder="e.g. +1 1234567890"
                            value={phone_number}
                            onChange={(value) =>
                              handleOnChange({target: {value}}, "phone_number")
                            }
                          />
                          <FormText>Select country and enter mobile number</FormText>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <hr className="my-4" />
                </Form>
              </CardBody>
            </Card>
          </Col>
          <Col className="mt-3 mt-xl-0" xl="4">
            <Card className="bg-secondary shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">Settings</h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody className="pt-4">
                <Settings profile={profile} handleChange={handleChange} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </SafeView>
  );
};

export default Profile;
